module.exports = __webpack_public_path__ + "img/about-map-1.307a7559.png";